const menu = document.querySelector('div#menu');
const menuBreakpoint = 984;

// traductions
var lang = document.documentElement.lang || global.default_lang || 'fr';

const openSubmenu = {
    fr: 'Ouvrir le sous-menu « %1$s »',
    en: 'Open the “%1$s” submenu',
    de: 'Untermenü „%1$s“ öffnen',
};

const closeSubmenu = {
    fr: 'Fermer le sous-menu « %1$s »',
    en: 'Close the “%1$s” submenu',
    de: 'Untermenü „%1$s“ schließen',
};

const openSubmenuText = openSubmenu[lang] || openSubmenu[global.default_lang] || openSubmenu.fr;
const closeSubmenuText = closeSubmenu[lang] || closeSubmenu[global.default_lang] || closeSubmenu.fr;

window.addEventListener('load', function () {
    //
    // scroll tout en haut de la page lors de l'ouverture du menu
    //
    const open = document.querySelector('.hamburger.hamburger-open');

    if (open) {
        open.addEventListener('click', () => {
            window.scrollTo({
                behavior: 'smooth',
                top: 0,
            });
        });
    }

    //
    // récupération du texte d'un lien
    //
    function getVisibleText(element) {
        return element ? element.textContent.trim() : '';
    }

    //
    // fermeture d'un élément de liste
    //
    function closeItem(item, force = false) {
        if (!force && window.innerWidth < menuBreakpoint) {
            return;
        }

        item.classList.remove('open', 'open-responsive');

        const button = item.querySelector('button.dropdown-toggle');
        const span = button ? button.querySelector('span.visually-hidden') : null;

        if (button) {
            const label = getVisibleText(button.previousElementSibling);

            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-label', openSubmenuText.replace('%1$s', label));

            if (span) {
                span.textContent = openSubmenuText.replace('%1$s', label);
            }
        }
    }

    //
    // configuration d'un bouton de dropdown
    //
    function initDropdownButton(button) {
        if (button) {
            const buttonLabel = getVisibleText(button.previousElementSibling);
            const span = button ? button.querySelector('span.visually-hidden') : null;

            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-label', openSubmenuText.replace('%1$s', buttonLabel));

            if (span) {
                span.textContent = openSubmenuText.replace('%1$s', buttonLabel);
            }

            const li = button.closest('li');

            // ouverture d'un élément parent de liste
            function openParent(current) {
                let parent = current.parentElement.closest('li');

                while(parent) {
                    const openClass = window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open';

                    if (!parent.classList.contains(openClass)) {
                        const parentButton = parent.querySelector('button.dropdown-toggle');
                        const parentSpan = parentButton ? parentButton.querySelector('span.visually-hidden') : null;

                        parent.classList.add(openClass);

                        if (parentButton) {
                            const label = getVisibleText(parentButton.previousElementSibling);

                            parentButton.setAttribute('aria-expanded', 'true');
                            parentButton.setAttribute('aria-label', closeSubmenuText.replace('%1$s', label));

                            if (parentSpan) {
                                parentSpan.textContent = closeSubmenuText.replace('%1$s', label);
                            }
                        }
                    }

                    parent = parent.parentElement.closest('li');
                }
            }

            // fermeture de tous les éléments de liste à la fermeture de l'élément parent de liste
            function closeChildren(parent) {
                const openClass = window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open';

                parent.querySelectorAll('li.' + openClass).forEach(child => {
                    if (child !== parent) {
                        const childButton = child.querySelector('button.dropdown-toggle');
                        const childSpan = childButton ? childButton.querySelector('span.visually-hidden') : null;

                        child.classList.remove(openClass);

                        if (childButton) {
                            const label = getVisibleText(childButton.previousElementSibling);

                            childButton.setAttribute('aria-expanded', 'false');
                            childButton.setAttribute('aria-label', openSubmenuText.replace('%1$s', label));

                            if (childSpan) {
                                childSpan.textContent = openSubmenuText.replace('%1$s', label);
                            }
                        }
                    }
                });
            }

            // gestion du clic sur le bouton
            if (li) {
                button.addEventListener('click', function (e) {
                    e.stopPropagation();

                    let open;

                    if (window.innerWidth < menuBreakpoint) {
                        open = li.classList.toggle('open-responsive');
                    } else {
                        open = li.classList.toggle('open');
                    }

                    button.setAttribute('aria-expanded', open ? 'true' : 'false');
                    button.setAttribute('aria-label', (open ? closeSubmenuText.replace('%1$s', buttonLabel) : openSubmenuText.replace('%1$s', buttonLabel)));

                    if (span) {
                        span.textContent = (open ? closeSubmenuText.replace('%1$s', buttonLabel) : openSubmenuText.replace('%1$s', buttonLabel));
                    }

                    if (open) {
                        openParent(li);
                    } else {
                        closeChildren(li);
                    }
                });
            }

            // gestion de la navigation au clavier
            if (li) {
                button.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();

                        let open;

                        if (window.innerWidth < menuBreakpoint) {
                            open = li.classList.toggle('open-responsive');
                        } else {
                            open = li.classList.toggle('open');
                        }

                        button.setAttribute('aria-expanded', open ? 'true' : 'false');
                        button.setAttribute('aria-label', (open ? closeSubmenuText.replace('%1$s', buttonLabel) : openSubmenuText.replace('%1$s', buttonLabel)));

                        if (span) {
                            span.textContent = (open ? closeSubmenuText.replace('%1$s', buttonLabel) : openSubmenuText.replace('%1$s', buttonLabel));
                        }

                        if (open) {
                            openParent(li);
                        } else {
                            closeChildren(li);
                        }
                    }
                });
            }

            // gestion de la perte de focus
            if (li) {
                li.addEventListener('focusout', function (e) {
                    const next = e.relatedTarget;

                    if (!next) {
                        return;
                    }

                    if (li.contains(next)) {
                        return;
                    }

                    const nextLi = next.closest('li');

                    if (nextLi && (nextLi.contains(li) || li.contains(nextLi))) {
                        return;
                    }

                    closeItem(li);
                });
            }
        }
    }

    //
    // initialisation de tous les boutons de sous-menu
    //
    menu.querySelectorAll('button.dropdown-toggle').forEach(initDropdownButton);

    //
    // fermeture des éléments de liste ouverts lors du survol d'un autre élément de liste
    //
    menu.querySelectorAll('li').forEach(li => {
        li.addEventListener('mouseenter', function () {
            if (window.innerWidth < menuBreakpoint) {
                return;
            }

            menu.querySelectorAll('li.open').forEach(item => {
                if (!item.contains(li) && !li.contains(item)) {
                    closeItem(item);
                }
            });
        });
    });

    //
    // fermeture des éléments de liste ouverts lors d'un clic en dehors
    //
    document.addEventListener('click', function (e) {
        menu.querySelectorAll('li.' + (window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open')).forEach(item => {
            if (!item.contains(e.target)) {
                closeItem(item);
            }
        });
    });

    //
    // fermeture du menu et de tous les sous-menus lors du redimensionnement de la fenêtre
    //
    let wasMobile = window.innerWidth < menuBreakpoint;

    window.addEventListener('resize', () => {
        const isMobile = window.innerWidth < menuBreakpoint;

        if (wasMobile !== isMobile) {
            document.querySelectorAll('#menu li.open, #menu li.open-responsive').forEach(item =>
                closeItem(item, {
                    force: true,
                })
            );
        }

        wasMobile = isMobile;
    });
});